export const paymentTypeFieldName = "paymentType";
export const paymentMethodStatusFieldName = "paymentMethodStatus";
export const id = "id";

//ach
export const routingNumberFieldName = "routingNumber";
export const accountNumberFieldName = "accountNumber";
export const bankAccountFieldName = "bankAccountName";
export const bankFieldName = "bankName";
//credit card
export const customerIdFieldName = "customerId";
export const cardHolderNameFieldName = "cardHolderName";
export const expirationDateFieldName = "expirationDate";
export const cvvFieldName = "cvv";
export const payeeFirstNameFieldName = "payeeFirstName";
export const payeeLastNameFieldName = "payeeLastName";
export const cardNumberFieldName = "cardNumber";
export const cardTypeFieldName = "cardType";
